<template>
  <div class="copyright-footer text-wrapper_6 flex-row">
     
    
    
    <span class="paragraph_1">
       <span class="paragraph_title">上级单位：</span>  
       生态保护与修复协会  、
       碳中和技术生态促进工作委员会<br /> 
       <span class="paragraph_title">主办单位: </span>  
       党在我心中青山绿水行组委会 、
       中广联智媒委·生态保护修复与智慧应急传播研究室<br />
       <span class="paragraph_title">合办单位:  </span>
       CCTV高清娱乐频道《为民普法》栏目·环境法治专栏 、
       中国纪检廉政调研部·廉政法治头闻网<br />
       <span class="paragraph_title">法律支持:  </span>
       北京海归科协法律专业委员会 <br />
       <span class="paragraph_title">高校合作: </span>
       中国石油大学（北京）管道安全与技术研究中心  、
       北京工商大学·国家战略发展研究院 <br />
      <span class="paragraph_title">版权所有:</span>{{ basicData.appCopyright || '生态保护与修复报道中心'}}
      <br />
      <span class="paragraph_title">技术支持:</span>传承（广州）网络技术有限公司
      <br />
      <span class="paragraph_title">备案号:</span> <span class="title_a" @click="openBeian"> 京ICP备2026045364号-1 </span>
      <br />
      <!-- 
      <span class="paragraph_title">
        <img src="../assets/img/ga_logo.png" style="height: 15px; line-height: 15px;"/>
        公安备案号:
      </span> 
      <span class="title_a" @click="openGongAnBeian('11010202010818')">京公网安备11010202010818号</span> 
-->
    </span>
   
  </div>
</template>

<script>
export default {
  name: 'CopyrightFooter',
  computed: {
    basicData() {
      const data = window.__appBasic || {}
      if (data.appLogo) {
        data.appLogoImg = JSON.parse(data.appLogo)[0].url
      }
      return data
    }
  },
  methods: {
    openBeian(){
      window.open('https://beian.miit.gov.cn/');
    },
    openGongAnBeian(code){
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+code);
    },
  }
}
</script>

<style scoped lang="scss">
.text-wrapper_6 {
  margin: 16px auto 0;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  .paragraph_1 { 
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 10px;
    line-height: 15px;
    text-align: center;
    .paragraph_title{
      font-weight: bold;
    }
    .title_a{
      cursor: pointer;
    }
  }
}
</style>
